<template>
    <div class="adsSourceExtendMapEdit">
		<div v-if="typeof $route.params.ads_ex_id=='undefined'">
			<h4>Ничего не передано</h4>
		</div>
		<div v-else>
			<div class="bntGroup">
				<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
			</div>
			<card>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
			</card>
		</div>
    </div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
	name: 'adsSourceExtendMap-page',
	components: {
        ReFormPrinter,
	},
	data() {
		return {
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
		};
	},
	methods: {
		currentFormConfig() {
			let result_id = typeof this.$route.params.ads_ex_id=='undefined'?null:this.$route.params.ads_ex_id;
			this.$GVO.ApiCall('adsSourceExtendMap.GET_FORM_MODEL',{flt:{'result_id':result_id}})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
			let result_id = typeof this.$route.params.ads_ex_id=='undefined'?'0':this.$route.params.ads_ex_id;
            return {apiMethod:'adsSourceExtendMap.INSUPD',apiParam:{iData:[],flt:{'id':result_id}}};
        },
		SuccessGo(evt,dopParam){
	        this.$router.go(-1);
		},
		GoBack(){
			this.$router.back();
			// this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id});
		},
	},		
	mounted() {

	}
};
</script>
<style scoped>
.adsSourceExtendMapEdit .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
</style>
